<template>
    <!-- 需要企业审核通过的页面 -->
    <div class="auth-conatiner">
        <slot v-if="hasAuth"/>
        <un-auth v-else/>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UnAuth from './un-auth'
export default {
    name: 'auth-page',
    components: {
        UnAuth
    },
    computed: {
        ...mapGetters(['user']),
        hasAuth () {
            // 用户type为0表示企业超级管理员 1为企业会员
            return this.user.type !== 0 || (this.user.type === 0 && this.user.authStatus === 3)
        }
    }
}
</script>

<style lang="less">
.auth-conatiner {
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/page/auth.vue